import React, { useState, useEffect, Fragment } from 'react';
import { matchPath } from 'react-router-dom';
import { useQuery } from 'react-apollo';

import Button from '../../../../../components/global/Button';
import usePurchasesPendingConfiguration from '../../../../../apps/pro/views/HierarchyItem/Matches/components/PurchasesPendingConfiguration/hooks/usePurchasesPendingConfiguration';
import PurchasesPendingConfiguration from '../../../../../apps/pro/views/HierarchyItem/Matches/components/PurchasesPendingConfiguration/PurchasesPendingConfiguration';
import { getAlbumMembershipGroupQuery } from '../../../../../apps/temp/views/memberships/AlbumMembershipGroup/graphql/queries/getAlbumMembershipGroup';

const CheckoutCartPendingPurchases = ({ location }) => {
  const match = matchPath(location.pathname, {
    path: '/app/shutterbug/hierarchy-items/:hierarchyItemId',
    exact: false,
  });
  const consumersMatch = matchPath(location.pathname, {
    path: '/consumer/matches/:albumMembershipGroupId',
    exact: false,
  });

  const albumMembershipGroupId =
    match?.params?.hierarchyItemId ??
    consumersMatch?.params?.albumMembershipGroupId;

  const [configuring, setConfiguring] = useState(false);
  const { data: { albumMembershipGroup } = {} } = useQuery(
    getAlbumMembershipGroupQuery,
    {
      variables: {
        id: albumMembershipGroupId,
      },
      skip: !albumMembershipGroupId,
      fetchPolicy: 'cache-first',
    },
  );

  const hierarchyItemId = albumMembershipGroup?.is_album
    ? albumMembershipGroup.album.root_album_folder?.id
    : albumMembershipGroup?.id;

  const {
    prepaidPrintPackagesMissingConfiguration,
    prepaidPhotoPricingsMissingConfiguration,
    prepaidCustomPrintsMissingConfiguration,
  } = usePurchasesPendingConfiguration({
    hierarchyItemId,
    shippableOnly: true,
  });

  const itemsMissingConfigurationTotal =
    (prepaidPrintPackagesMissingConfiguration?.length ?? 0) +
    (prepaidPhotoPricingsMissingConfiguration?.length ?? 0) +
    (prepaidCustomPrintsMissingConfiguration?.length ?? 0);

  useEffect(() => {
    if (itemsMissingConfigurationTotal === 0) {
      setConfiguring(false);
    }
  }, [itemsMissingConfigurationTotal]);

  if (itemsMissingConfigurationTotal === 0) {
    return null;
  }

  return (
    <div className="prepaid-items-missing-configuration-warning">
      {itemsMissingConfigurationTotal > 0 && (
        <Fragment>
          <p className="text-sm">
            Additional shipping fees will be incurred for separate shipments.
            Configure your remaining purchases ({itemsMissingConfigurationTotal}
            ) and ship everything together to save on shipping fees!
          </p>

          <Button
            btnStyle="white"
            btnOutline
            btnSize="sm"
            pill
            className="text-bold"
            onClick={() => setConfiguring(prev => !prev)}
          >
            Configure now
          </Button>
          {configuring && (
            <div className="checkout-pending-purchases-overlay">
              <PurchasesPendingConfiguration
                startExpanded
                shippableOnly
                hierarchyItemId={hierarchyItemId}
                className="checkout-pending-purchases-collapsable"
                onExpand={() => setConfiguring(false)}
                onCheckout={() => setConfiguring(false)}
                optionProps={{
                  onConfigurationComplete: null,
                }}
              />
            </div>
          )}
        </Fragment>
      )}
    </div>
  );
};

export default CheckoutCartPendingPurchases;
